// this.$store.state.control
import { serverTimestamp } from "firebase/firestore";

/* CLASE CONTROL DE PERSONAL */
export const control = class {
  constructor() {
    return {
      id: "",
      idEmpresa: "",
      idHorario: "",
      idUsuario: "",
      fechaFiltro: new Date().toLocaleDateString("en-CA"),
      registro: {
        creacion: serverTimestamp(),
        actualizacion: serverTimestamp(),
        estado: "Creado",
        realizadoPor: {
          entrada: "",
          salida: "",
        },
        tipo: {
          entrada: "",
          salida: "",
        },
      },
      ubicacion: {
        entrada: {
          latitud: "",
          longitud: "",
        },
        salida: {
          latitud: "",
          longitud: "",
        },
      },
    };
  }
};
